export enum RescType {
  ROUTE = 'ROUTE',
  ELEMENT = 'ELEMENT',
  ACTION = 'ACTION',
  ATTR = 'ATTR',
}
